/**
 * A pixel coordinate rounded to a tenth, half away from zero, written
 * without a float-to-string conversion: the rounded tenths are an integer,
 * and integers print fast. A value that rounds to zero prints unsigned.
 */
function tenths(value: number): string {
    const rounded = Math.round(Math.abs(value) * 10);
    const fraction = rounded % 10;
    const whole = (rounded - fraction) / 10;
    const text = fraction === 0 ? `${whole}` : `${whole}.${fraction}`;
    return value < 0 && rounded !== 0 ? `-${text}` : text;
}

/**
 * The `d` attribute of an SVG path through `points` in order: a move to the
 * first point and a line to each next one. A point whose y is `null` is a
 * gap: the path breaks there and moves to the next defined point. Pixel
 * coordinates are rounded to a tenth of a pixel, half away from zero, below
 * what a screen can show, so the string stays short. An empty or all-gap input gives ''.
 */
export function linePathD<Point>(
    points: readonly Point[],
    toX: (point: Point) => number,
    toY: (point: Point) => number | null
): string {
    let d = '';
    let pendingMove = true;
    for (let i = 0; i < points.length; i++) {
        const y = toY(points[i]);
        if (y === null) {
            pendingMove = true;
            continue;
        }
        d += `${pendingMove ? 'M' : 'L'}${tenths(toX(points[i]))},${tenths(y)}`;
        pendingMove = false;
    }
    return d;
}
